<template>
  <section class="admin-content">
    <Navbar />
    <main class="admin-main">
      <div class="chat-wrap">
        <div class="chat-shell shadow-sm">
          <div class="chat-left" :class="{ 'chat-hide-sm': showingThread }">
            <ConversationList ref="list" :active-id="activeId" @select="openConversation" @new="picking = true" />
          </div>
          <div class="chat-right" :class="{ 'chat-hide-sm': !showingThread }">
            <ConversationThread
              v-if="activeId"
              :key="'c' + activeId"
              :conversation-id="activeId"
              :types="types"
              @back="$router.push('/messages')"
              @changed="refreshList"
            />
            <ConversationThread
              v-else-if="draft"
              :key="draftKey"
              :draft="draft"
              :types="types"
              @back="draft = null"
              @created="onCreated"
            />
            <div v-else class="chat-idle">
              <span class="chat-idle-icon"><i class="fe fe-message-circle"></i></span>
              <h5 class="font-weight-bold mt-3 mb-1">Your chats</h5>
              <p class="text-muted mb-3">Pick a chat on the left, or start a new one.</p>
              <button type="button" class="btn chat-btn btn-sm px-4" @click="picking = true">
                <i class="fe fe-edit mr-1"></i> New chat
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <NewChatModal v-if="picking" @close="picking = false" @open="openFromPicker" @draft="startDraft" />
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import ConversationList from "../components/ConversationList.vue";
import ConversationThread from "../components/ConversationThread.vue";
import NewChatModal from "../components/NewChatModal.vue";
import chat from "../store";
import { chatEnabledFor, storedUser } from "../config";

// /messages and /messages/:id — chats on the left, the open chat on the right
// (one at a time on small screens).
export default {
  name: "Messages",
  components: { Navbar, ConversationList, ConversationThread, NewChatModal },
  data() {
    return { picking: false, draft: null, draftKey: 0, types: [] };
  },
  computed: {
    activeId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null;
    },
    showingThread() {
      return !!(this.activeId || this.draft);
    },
  },
  watch: {
    activeId(id) {
      if (id) this.draft = null;
    },
  },
  created() {
    if (!chatEnabledFor(storedUser())) {
      this.$router.replace("/pusher").catch(() => {});
      return;
    }
    chat.start();
    chat.loadEntityTypes().then((types) => (this.types = types));
    if (this.$route.query.new) this.picking = true;
  },
  methods: {
    openConversation(id) {
      this.draft = null;
      if (Number(id) !== this.activeId) this.$router.push(`/messages/${id}`).catch(() => {});
    },
    openFromPicker(id) {
      this.picking = false;
      this.openConversation(id);
    },
    startDraft(draft) {
      this.picking = false;
      this.draft = draft;
      this.draftKey += 1;
      if (this.activeId) this.$router.push("/messages").catch(() => {});
    },
    onCreated(conversation) {
      this.refreshList();
      this.openConversation(conversation.id);
    },
    refreshList() {
      if (this.$refs.list) this.$refs.list.refresh();
    },
  },
};
</script>

<style scoped>
.chat-wrap {
  padding: 16px;
}
.chat-shell {
  display: flex;
  height: calc(100vh - 65px - 32px); /* below the fixed header, 16px margin top and bottom */
  min-height: 420px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}
.chat-left {
  width: 360px;
  flex-shrink: 0;
  border-right: 1px solid #e9ecef;
}
.chat-right {
  flex: 1;
  min-width: 0;
}
.chat-idle {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  background: #f8fafc;
}
.chat-idle-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #eef2ff;
  color: #2563eb;
  font-size: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991.98px) {
  .chat-left {
    width: 300px;
  }
}
@media (max-width: 767.98px) {
  .chat-wrap {
    padding: 0;
  }
  .chat-shell {
    height: calc(100vh - 65px);
    border-radius: 0;
    border: 0;
  }
  .chat-left {
    width: 100%;
    border-right: 0;
  }
  .chat-hide-sm {
    display: none;
  }
}
</style>
